import { Component, Input } from '@angular/core'
import { EbAvailabilityItem } from '../../interfaces/eb-availability.interface'

@Component({
    selector: 'eb-product-availability',
    templateUrl: './eb-product-availability.component.html',
    styleUrls: ['./eb-product-availability.component.scss'],
    standalone: false
})
export class EbProductAvailabilityComponent {
  @Input() availability!: EbAvailabilityItem
  @Input() error = false
  @Input() inverseAlignment = false

  get color() {
    return this.availability?.statusCode?.toLowerCase() || 'empty'
  }

  get textId() {
    const withDate = this.date ? 'withDate.' : ''
    const token = this.error ? 'error' : this.availability?.statusTextId || 'error'
    const prefix = 'availability.'
    return prefix + withDate + token
  }

  get date() {
    return this.availability?.availableDate
  }
}
